import { render, staticRenderFns } from "./ErrorLampsOnCent.vue?vue&type=template&id=48aff78a&"
import script from "./ErrorLampsOnCent.vue?vue&type=script&lang=js&"
export * from "./ErrorLampsOnCent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports